/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import { fetchConfigDetail, listConfigurations, toggleConfigDrawer, toggleConfigDrawerContent, fetchConfigurationAudit } from '../actions/configurations';
import { inProgress } from '../actions/common';
export const configurationReducer = createReducer(InitialState.configurations, (builder)=>{
    builder.addCase(UIActions.logout.type, ()=>({
            ...InitialState.configurations
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.configurations
        }));
    builder.addCase(inProgress, (state)=>({
            ...state
        }));
    builder.addCase(listConfigurations.fulfilled, (state, action)=>({
            ...state,
            configurations: action.payload
        }));
    builder.addCase(listConfigurations.rejected, (state)=>({
            ...state
        }));
    builder.addCase(fetchConfigDetail.fulfilled, (state, action)=>({
            ...state,
            configurationDetail: action.payload
        }));
    builder.addCase(fetchConfigDetail.rejected, (state, action)=>({
            ...state,
            configDetailError: action.error
        }));
    builder.addCase(fetchConfigurationAudit.fulfilled, (state, action)=>({
            ...state,
            configurationAuditHistory: action.payload
        }));
    builder.addCase(fetchConfigurationAudit.rejected, (state, action)=>({
            ...state,
            configAuditError: action.error
        }));
    builder.addCase(toggleConfigDrawer, (state, action)=>({
            ...state,
            isDrawerOpen: action.payload
        }));
    builder.addCase(toggleConfigDrawerContent, (state, action)=>({
            ...state,
            isDrawerContentOpen: action.payload
        }));
});
export default configurationReducer;
